import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import DeliveryForm from "./DeliveryComponents/DeliveryForm"; 

import {
  useGetDeliveryDetailQuery,
  useUpdateDeliveryMutation, 
} from "store/services/deliveryApi"; 

import { useAppMeta } from "hooks";

const DeliveryEditScreen = () => {  

  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Deliveries", path: "/app/crm/delivery/list" }, 
    { title: "Edit Delivery" }, 
  ];

  // RTK Query
  const { data: deliveryDetail, isLoading: loadingDeliveryDetail, error } = useGetDeliveryDetailQuery(id);  

  const [updateDelivery, { isLoading: updatingDelivery }] = useUpdateDeliveryMutation(); 

  // Update handler
  const handleUpdateDelivery = async (data) => {  
    const payload = { id, ...data };

    try {
      await updateDelivery(payload).unwrap();  
      toast.success("Delivery successfully updated!");
      navigate(`/app/crm/delivery/${id}/detail`); 
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update delivery!"
      );
    }
  };

  useAppMeta("Edit Delivery");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingDeliveryDetail || updatingDelivery} 
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <DeliveryForm  // Updated component usage
          isBusy={loadingDeliveryDetail || updatingDelivery} 
          deliveryDetail={deliveryDetail}  
          onSubmit={handleUpdateDelivery} 
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default DeliveryEditScreen;  